<template>
    <div>
        <img :src="imgUrl" />
    </div>
</template>
<script>
export default {
    data(){
        return{
            imgUrl:'',
            id:'',
        }
    },
    mounted(){
        this.id = this.$route.query.id == undefined ? '' : this.$route.query.id;
        this.getImgUrl();
    },
    methods:{
        getImgUrl(){
            let that = this;
            let data = {'id':this.id};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/login/getqrcodeimg.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.imgUrl = res.data.imgUrl;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/qrcodeimg.vue